import { Navigate, Outlet } from 'react-router-dom';
import { Spinner } from '../../shared/ui/Spinner';
import { useAppStore } from '../../store/useAppStore';
import type { Role } from '../../shared/types/app';

type Props = {
  role: Role;
  redirectTo: string;
};

export function RequireRole({ role, redirectTo }: Props) {
  const user = useAppStore((s) => s.user);

  // Still loading profile
  if (user === null) {
    return (
      <div className="flex h-screen items-center justify-center bg-bg">
        <Spinner size="lg" />
      </div>
    );
  }

  if (user.role !== role) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
}
